import { AnyDocument } from '../../../types';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentUserdataQueryKey = <DocumentType extends AnyDocument>(
  documentId: DocumentType['id'],
  documentParams: DocumentParams,
  mergedParams: Record<string, unknown>,
) => [
  DOCUMENTS_BASE_PATH,
  'documentUserdata',
  documentId,
  documentParams,
  mergedParams,
];
